import React from 'react';
import { Helmet } from 'react-helmet';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { PLAN_CREATION_REASONS } from '../../../contexts/create-plan-context/create-plan-context-types/plan-create-reason';
import type { PlanCreationStep } from '../../../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { PLAN_CREATION_STEPS } from '../../../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { CreatePlanProvider } from '../../../contexts/create-plan-context/CreatePlanProvider/CreatePlanProvider';
import { FormErrorNotificationProvider } from '../../../contexts/form-error-notification-context/FormErrorNotificationProvider';
import { prefetchMeters } from '../../../hooks/requests/use-meters/use-meters';
import { CreatePlanErrorNotification } from '../../plans/CreatePlanPage/create-plan-page-components/CreatePlanErrorNotification/CreatePlanErrorNotification';
import { CreatePlanPageHeader } from '../../plans/CreatePlanPage/create-plan-page-components/CreatePlanPageHeader';
import { CreatePlanPageStepperNavigator } from '../../plans/CreatePlanPage/create-plan-page-components/CreatePlanPageStepperNavigator';
import { CreatePlanPageTabs } from '../../plans/CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/CreatePlanPageTabs';
import { CreatePlanPageContent } from '../../plans/CreatePlanPage/create-plan-page-components/NewCreatePlanPageContent/CreatePlanPageContent';
import { PlanSettings } from '../../plans/CreatePlanPage/create-plan-page-components/PlanSettings';
import { CONTRACT_UPDATE_STEPS_CTA_LABELS } from '../../plans/CreatePlanPage/create-plan-page-consts/create-plan-default-values';
import { withPrefetch } from '../../../components/hocs';
import { UpdateContractForm } from './update-contract-page-components/UpdateContractForm';
import { useUpdateContractSubmitter } from './update-contract-page-hooks/useUpdateContractSubmitter';

const CONTRACT_UPDATE_STEPS_CONTENT: Record<PlanCreationStep, React.ReactElement> = {
  [PLAN_CREATION_STEPS.pricingAndProducts]: <CreatePlanPageTabs />,
  [PLAN_CREATION_STEPS.settings]: <PlanSettings />,
};

const UpdateContractPage: React.FC = () => {
  const submitEditContract = useUpdateContractSubmitter();

  return (
    <>
      <Helmet>
        <title>Update Contract</title>
      </Helmet>
      <CreatePlanProvider
        planCreationReason={PLAN_CREATION_REASONS.EditContract}
        defaultPlanCreationStep={PLAN_CREATION_STEPS.settings}
        onFormSubmission={submitEditContract}
      >
        <UpdateContractForm>
          <FormErrorNotificationProvider>
            <CreatePlanPageHeader />

            <CreatePlanErrorNotification />

            <CreatePlanPageContent stepsContent={CONTRACT_UPDATE_STEPS_CONTENT} />

            <CreatePlanPageStepperNavigator
              stepsLabels={CONTRACT_UPDATE_STEPS_CTA_LABELS}
              formClearable={false}
            />
          </FormErrorNotificationProvider>
        </UpdateContractForm>
      </CreatePlanProvider>
    </>
  );
};

const UpdateContractPageWithSuspenseBoundary = withSuspenseBoundary(
  withPrefetch(UpdateContractPage, prefetchMeters),
);
export { UpdateContractPageWithSuspenseBoundary as UpdateContractPage };
